import React from "react";
import { Checkbox, Popover, Button, Row, Col } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import classes from "./profile.module.css";

class CheckboxMenuForStatus extends React.Component {
  state = {
    text: "",
    icon: {},
    selectedItems: [],
  };

  componentDidMount = () => {
    if (this.props.value && this.props.value.length) {
      this.setState(
        {
          selectedItems: [...this.props.value],
          text: this.props.text,
        },
        () => this.checkIconFilled()
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState(
        {
          selectedItems: [...this.props.value],
          text: this.props.text,
        },
        () => this.checkIconFilled()
      );
    }
  }

  onChange = (selection) => {
    this.setState({ selectedItems: [...selection] }, () => {
      this.checkIconFilled();
    });

    if (this.props.onChange) {
      this.props.onChange(selection);
    }
  };

  checkIconFilled = () => {
    if (this.state.selectedItems.length) {
      this.setState({ icon: { theme: "filled" } });
    } else {
      this.setState({ icon: {} });
    }
  };

  checkboxRender = () => {
    const groups = this.props.options
      .map((e, i) =>
        i % 10 === 0 ? this.props.options.slice(i, i + 10) : null
      )
      .filter((e) => e);

    return (
      <Checkbox.Group
        onChange={this.onChange}
        style={{ maxWidth: 500, maxHeight: 300, overflowY: "auto" }}
        value={this.state.selectedItems}
      >
        <Row>
          {groups.map((group, i) => (
            <Col
              key={"checkbox-group-" + i}
              span={Math.floor(24 / groups.length)}
            >
              {group.map((label, index) => (
                <Checkbox
                  className={classes.checkbox}
                  key={label}
                  value={label}
                >
                  {label === "PENDING" && "Шинэ"}
                  {label === "APPOINTED" && "Урилга илгээсэн"}
                  {label === "CARRIED_OUT" && "Батлагдсан"}
                  {label === "REJECTED" && "Татгалзсан"}
                </Checkbox>
              ))}
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    );
  };

  render() {
    return (
      <Popover
        content={this.checkboxRender()}
        trigger="click"
        placement="bottomLeft"
        zIndex={100000}
      >
        <Button>
          {this.state.text} <FilterOutlined {...this.state.icon} />
        </Button>
      </Popover>
    );
  }
}

export default CheckboxMenuForStatus;
